import { isSafariBrowser } from './platform';

export const browserTarget = isSafariBrowser ? '' : '_blank';

/**
 * Converts a four figit number to a time. Ex. '2100' returns '21:00'.
 *
 * @param {Number | string} fourDigitNumber - the four digit number to be converted to time.
 * @returns {string} The time version of the number or string passed in.
 * @public
 */
export function parse4DigitTime(fourDigitNumber) {
  if (Number.isNaN(fourDigitNumber)) {
    throw new TypeError(`fourDigitNumber is not a number: ${fourDigitNumber}`);
  }

  let fourDigitString = typeof fourDigitNumber === 'number'
    ? fourDigitNumber.toString()
    : fourDigitNumber;

  fourDigitString = fourDigitString.trim();

  if (fourDigitString.length !== 4) {
    throw new Error(`fourDigitNumber is not four digits: ${fourDigitString}`);
  }

  const hours = fourDigitString.substr(0, 2);
  const minutes = fourDigitString.substr(2, 2);

  if (parseInt(hours, 10) > 23 || parseInt(minutes, 10) > 59) {
    throw new Error('fourDigitNumber is invalid: ', fourDigitString);
  }

  return `${hours}:${minutes}`;
}

export const formatMoney = (value = 0, currency = 'CAD', precision = 0) => new Intl.NumberFormat('en-CA',
  {
    style: 'currency',
    currency,
    currencyDisplay: 'symbol',
    minimumFractionDigits: precision,
    maximumFractionDigits: precision,
  }).format(value);

/**
 * Returns the phone number passed in formated as "(xxx) xxx-xxxx".
 *
 * @param {String} phone number to format
 * @returns {String} The phone number in the format "(xxx) xxx-xxxx",
 * or '' if not a 10 digit phone number
 * @public
 */

export function formatPhoneNumber(phone) {
  if (!phone || phone.length !== 10) return '';

  const areaCode = phone.substr(0, 3);
  const firstChunk = phone.substr(3, 3);
  const secondChunk = phone.substr(6, 4);

  return `(${areaCode}) ${firstChunk}-${secondChunk}`;
}
